// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ZoneXLanding from './LandingPage';
import ParkingServicePage from './pages/ParkingServicePage';
import MechanicsServicePage from './pages/MechanicsServicePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Layout component that wraps each page with Navbar and Footer
const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};

// ScrollToTop component to handle scrolling to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // Multiple methods to ensure scrolling
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App bg-zonex-white min-h-screen text-zonex-gray-900">
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <ZoneXLanding />
              </Layout>
            }
          />
          <Route
            path="/parking"
            element={
              <Layout>
                <ParkingServicePage />
              </Layout>
            }
          />
          <Route
            path="/mechanics"
            element={
              <Layout>
                <MechanicsServicePage />
              </Layout>
            }
          />
          <Route
            path="/about"
            element={
              <Layout>
                <AboutPage />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <ContactPage />
              </Layout>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;